import React, { useContext } from 'react';
import { ChatService } from '@/features/AiChat/model/context/types.ts';
import { initialValue } from '@/features/AiChat/model/context/default-value';

export const AiChatContext = React.createContext<ChatService>(initialValue);

export const useAiChatContext = () => useContext(AiChatContext);